import { render, staticRenderFns } from "./AgendaStatiListComponent.vue?vue&type=template&id=dbd4cf08"
import script from "./AgendaStatiListComponent.vue?vue&type=script&lang=js"
export * from "./AgendaStatiListComponent.vue?vue&type=script&lang=js"
import style0 from "./AgendaStatiListComponent.vue?vue&type=style&index=0&id=dbd4cf08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports